import { render, staticRenderFns } from "./PreferencesIndex.vue?vue&type=template&id=64b50e49&scoped=true&"
import script from "./PreferencesIndex.vue?vue&type=script&lang=js&"
export * from "./PreferencesIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b50e49",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
